import Link from 'next/link';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/nextjs';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);

    Sentry.captureException(error, {
      extra: {
        componentStack: errorInfo.componentStack,
      },
    });

    //TODO: Get better error messaging from backend and only route to login if this is a token expired issue
    // router.push({
    //   pathname: '/api/auth/login?redirect-url=' + router.pathname.substring(1),
    // });
  }
  public render() {
    if (this.state.hasError) {
      return (
        <>
          <h1>
            Looks like there was an error. If you are not redirected in 5
            seconds{' '}
            <Link
              href={`/api/auth/login?redirect-url=${window.location.pathname}`}
            >
              <a className="underline text-confirmed-primary">click here</a>
            </Link>
          </h1>
          <h2>
            Still having issues?{' '}
            <a
              className="underline hover:cursor-pointer"
              target="_blank"
              href={'mailto:support@confirmedapp.com?subject = Feedback'}
            >
              Email Support
            </a>
          </h2>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
